/* Astra Analytics v0.2.0. Theme-side attention and Clarity metadata; transport is the Shopify custom pixel. */
(() => {
  if(window.__astraAnalytics)return;
  window.__astraAnalytics=true;
  if(window.Shopify?.designMode)return;
  let page=crypto.randomUUID();
  let started=false,consented=false,last=performance.now(),lastInput=last,pending=0,scroll=0;
  let wasActive=false,lastSent=0;
  let clarity=null,clarityRegistered=false,clarityGeneration=0,claritySent='';
  function ownerMode(){
    if(!privacy())return;
    const mode=new URL(location.href).searchParams.get('aa_owner');
    try{if(mode==='1'||window.Shopify?.theme?.role&&window.Shopify.theme.role!=='main')localStorage.setItem('aa_analytics_internal','1');else if(mode==='0')localStorage.removeItem('aa_analytics_internal');}catch{}
  }
  const privacy=()=>window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.()===true;
  const publish=(name,data={})=>{
    if(!privacy()||!window.Shopify?.analytics?.publish)return;
    window.Shopify.analytics.publish('astra_analytics:'+name,{page,...(clarity?{clarity}:{}),...data});
  };
  function resetClarity(){clarity=null;clarityRegistered=false;clarityGeneration++;claritySent='';}
  function connectClarity(){
    if(clarityRegistered||!started||!privacy()||typeof window.clarity!=='function')return;
    clarityRegistered=true;
    const generation=clarityGeneration;
    const receive=(metadata,playback)=>{
      if(generation!==clarityGeneration||!started||!privacy()||metadata?.projectId!=='ye4g9ry93g'||typeof playback!=='boolean')return;
      if(!['userId','sessionId'].every(key=>typeof metadata[key]==='string'&&/^[a-z0-9]{1,32}$/.test(metadata[key])))return;
      const next={projectId:metadata.projectId,userId:metadata.userId,sessionId:metadata.sessionId,playback};
      if(clarity?.userId===next.userId&&clarity?.sessionId===next.sessionId&&clarity.playback)next.playback=true;
      clarity=next;
      const key=JSON.stringify(next);if(key===claritySent)return;claritySent=key;
      publish('clarity_link');
    };
    try{
      // Immediate metadata and a second callback waiting for replay upgrade.
      // Existing Clarity handles its own capture/consent; no second SDK or identify call.
      window.clarity('metadata',receive,false);
      window.clarity('metadata',receive,true);
    }catch{clarityRegistered=false;}
  }
  const active=now=>document.visibilityState==='visible'&&document.hasFocus()&&now-lastInput<30000;
  function tick() {
    const now=performance.now(),allowed=privacy();
    // Never charge time before consent, after revocation, during a timer suspension or in a hidden tab.
    if(consented&&allowed&&wasActive)pending+=Math.max(0,Math.min(now-last,1000,Math.max(0,lastInput+30000-last)));
    last=now;wasActive=allowed&&active(now);consented=allowed;
    if(allowed&&!started&&window.Shopify?.analytics?.publish){ownerMode();started=true;lastInput=now;publish('page_enter');}
    if(!allowed){pending=0;started=false;if(clarityRegistered||clarity)resetClarity();}
    if(allowed)connectClarity();
    return now;
  }
  function flush(final=false) {
    const now=tick();
    if(!started||!consented)return;
    if(pending>0||final){publish('page_stats',{active_ms:Math.round(Math.min(pending,10000)),scroll,final});pending=0;}
    lastSent=now;
  }
  // Update the attention clock before each focus/visibility transition.
  for(const name of ['focus','blur','pageshow','pagehide'])window.addEventListener(name,event=>{
    if(name==='pageshow'&&event.persisted){page=crypto.randomUUID();resetClarity();started=false;pending=0;last=performance.now();lastInput=last;wasActive=false;}
    if(name==='pagehide')flush(true);else if(name==='blur')flush(false);else{tick();wasActive=privacy()&&active(performance.now());}
  });
  document.addEventListener('visibilitychange',()=>{flush(false);wasActive=privacy()&&active(performance.now());});
  document.addEventListener('visitorConsentCollected',()=>{tick();wasActive=privacy()&&active(performance.now());});
  for(const name of ['pointerdown','keydown','touchstart','scroll'])document.addEventListener(name,e=>{
    if(!e.isTrusted)return;
    tick();lastInput=performance.now();wasActive=privacy()&&active(lastInput);
    if(name==='scroll'){
      const range=document.documentElement.scrollHeight-window.innerHeight;
      if(range>0)scroll=Math.max(scroll,Math.min(100,Math.round(window.scrollY/range*100)));
    }
  },{passive:true});
  document.addEventListener('change',e=>{
    if(!e.isTrusted||!privacy())return;
    const el=e.target;
    if(el.matches('[data-aa-grade]')&&el.value){
      publish('trim_selected',{model:/rav-?4/i.test(location.pathname)?'RAV4':'Other',trim:el.value});
    }else if(el.matches('[data-aa-finish-choice]')&&el.value){publish('finish_selected',{model:/rav-?4/i.test(location.pathname)?'RAV4':'Other',finish:el.value});}
  });
  document.addEventListener('click',e=>{
    if(!e.isTrusted||!privacy())return;
    const link=e.target.closest('a[href]');
    if(link){
      let u;try{u=new URL(link.href,location.href);}catch{return;}
      // Model selection is a vehicle/collection navigation, never a product or generic RAV4 link.
      if(u.origin===location.origin&&u.pathname==='/collections/rav4-accessories'&&!u.hash)publish('model_selected',{model:'RAV4'});
    }
    if(e.target.closest('media-gallery, product-gallery, [data-aa-gallery], .aa-gallery, .aa-companion-gallery'))publish('product_interaction',{interaction:'Product gallery'});
    if(link)flush(false);
  });
  // First 10s: 500ms delivery resolution. Thereafter: 5s. The clock ticks every 250ms.
  setInterval(()=>{const now=tick();const cadence=now<10000?500:5000;if(now-lastSent>=cadence&&pending>0)flush();},250);
  // Fail closed while Shopify's consent API loads. Do not infer permission from the absence of a banner.
  if(!window.Shopify?.customerPrivacy&&window.Shopify?.loadFeatures){
    window.Shopify.loadFeatures([{name:'consent-tracking-api',version:'0.1'}],()=>tick());
  }
  tick();
})();
